import { atom } from "recoil";

import { CurrentEditKey } from "./frontEditCurrentEditKeys";

export type CurrentContentEdit = {
  key: CurrentEditKey;
  endpoint: string;
  data: any;
  jsonSchema: any;
  jsonUiSchema: any;
  invalidForm: boolean;
};

export const frontEditCurrentContentEditsState = atom<CurrentContentEdit[]>({
  key: "frontEditCurrentContentEditsState",
  default: [],
});
